export interface IUploadLinkResponseDto {
  signedURL: string;
  uploadId: string;
}

export interface IUploadDto {
  id: string;
  createdBy: string;
  type: FileType;
  createdAt: string;
  ttl: string;
  status: UploadStatus;
  errorMessage?: string;
  additionalData?: { [key: string]: any };
  parsingResults?: any;
}

export enum FileType {
  BTAT = 'BTAT',
  DAMEX = 'DAMEX',
  TRAVEL_RECEIPT = 'TRAVEL_RECEIPT',
  SAP_IMPORT = 'SAP_IMPORT',
  TRAVEL_MANAGEMENT = 'TRAVEL_MANAGEMENT',
  OTHER_COSTS = 'OTHER_COSTS',
  OUT_OF_OFFICE_ATTACHMENT = 'OUT_OF_OFFICE_ATTACHMENT',
}

export enum UploadStatus {
  READY_FOR_UPLOAD = 'READY_FOR_UPLOAD',
  UPLOADED = 'UPLOADED',
  AV_SCAN_DONE = 'AV_SCAN_DONE',
  AV_SCAN_FAILED = 'AV_SCAN_FAILED',
  DATA_PARSED = 'DATA_PARSED',
  PARSING_FAILED = 'PARSING_FAILED',
  USER_CANCELLED = 'USER_CANCELLED',
}
